import React from "react";
import "./about.css";
import aboutLeftImage from "../../../images/Agent Trust Images/assets/AboutSection/about-image.svg";
import icon1 from "../../../images/Agent Trust Images/assets/AboutSection/ai-transparency.svg";
import icon2 from "../../../images/Agent Trust Images/assets/AboutSection/regulatory-compliance.svg";
import icon3 from "../../../images/Agent Trust Images/assets/AboutSection/risk-mitigation.svg";
import icon4 from "../../../images/Agent Trust Images/assets/AboutSection/business-confidence.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
export default function About() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  const aboutPoints = [
    {
      heading: "AI Transparency",
      paragraph: "Understand how AI makes decisions.",
      icon: icon1,
    },
    {
      heading: "Regulatory Compliance",
      paragraph: "Ensure adherence to GDPR, HIPAA, and ISO 27001",
      icon: icon2,
    },
    {
      heading: "Risk Mitigation",
      paragraph: "Detect biases and security vulnerabilities proactively",
      icon: icon3,
    },
    {
      heading: "Business Confidence",
      paragraph: "Deploy AI solutions with measurable trust metrics",
      icon: icon4,
    },
  ];
  return (
    <section
      className={`agent-trust-about-section ${
        isVisible ? "section-animation" : ""
      }`}
      ref={ref}
      id="one"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>About</span>
          </div>
          <div className="heading-description">
            <h2>Unlock AI Trustworthiness with Transparent Scoring </h2>
            <p>
              AI Trust Score empowers organizations to assess and enhance AI
              systems based on fairness, security, and accuracy. By analysing
              key data and model factors, Agent Trust helps build confidence in
              AI-driven decisions.
            </p>
          </div>
        </div>
        <div className="agent-trust-about-section-content">
          <div className="agent-trust-about-section-left">
            <img src={aboutLeftImage} alt="about-img" />
          </div>
          <div className="agent-trust-about-section-right">
            <div className="agent-trust-about-section-pointers">
              {aboutPoints.map((point, index) => (
                <div key={index} className="about-pointer">
                  <img src={point.icon} alt="pointer-icon" />
                  <div>
                    <h3>{point.heading}</h3>
                    <p>{point.paragraph}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
